
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import Pagination from "@/components/Pagination/index.vue";
import ShippingRecord from "./ShippingRecord.vue";
import { formatPrice } from "@/utils/number";
import {queryHistoryPriceInPiForModel} from "@/api/proforma";

@Component({
  name: "PiHistoryPrice",
  components: {
    Pagination,
    ShippingRecord,
  },
})
export default class extends Vue {
  formatPrice = formatPrice;

  @Prop({ default: false }) private show!: boolean;
  @Prop({ default: "" }) private customerCode!: string;
  @Prop({ default: "" }) private customerAbbreviation!: string;
  @Prop({ default: "" }) private numberType!: string;
  @Prop({ default: "" }) private number!: string;
  @Prop({ default: () => ({}) }) private query!: Record<string, any>;

  private loading = false;
  private showShippingRecord = false;
  private shippingRecordRow = {} as Record<string, any>;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };

  get customerText() {
    const parts = [this.customerCode, this.customerAbbreviation].filter(Boolean);
    return parts.length ? parts.join(" ") : "-";
  }

  @Watch("show")
  private onShowChange(visible: boolean) {
    if (!visible) {
      return;
    }
    this.table.pageNumber = 1;
    this.getList();
  }

  private close() {
    this.$emit("update:show", false);
  }

  private async getList() {
    this.loading = true;
    try {
      const res: any = await queryHistoryPriceInPiForModel({
        customerId: this.query.customerId,
        numberTypeId: this.query.numberTypeId,
        number: this.query.number,
        pageNumber: this.table.pageNumber,
        pageSize: this.table.pageSize,
      });
      this.table.total = Number(res.total) || 0;
      this.table.list = res.list || [];
    } catch (err) {
      console.log(err);
      this.table.total = 0;
      this.table.list = [];
    } finally {
      this.loading = false;
    }
  }

  private formatCurrency(currency?: any) {
    if (currency == null || currency === "") {
      return "";
    }
    if (typeof currency === "object") {
      return currency.name || currency.desc || "";
    }
    return String(currency);
  }

  private formatDate(value?: string) {
    if (!value) {
      return "";
    }
    return moment(value).format("YYYY年MM月DD日");
  }

  private formatUnit(row: any) {
    const parts = [row.cnUnit, row.enUnit].filter(Boolean);
    return parts.length ? parts.join("/") : "-";
  }

  private formatDiscount(value?: number | string) {
    if (value === null || value === undefined || value === "") {
      return "";
    }
    return `${value} %`;
  }

  private hasSaleTooltip(row: any) {
    return row.salePrice != null || row.saleDiscount != null;
  }

  private hasPurchaseTooltip(row: any) {
    return row.purchasePrice != null || row.purchaseDiscount != null;
  }

  private handleShippingRecord(row: any) {
    this.shippingRecordRow = {
      ...row,
      pi: row.piCode,
      customerOrderQty: row.shipmentQty,
      currency: this.formatCurrency(row.currency),
    };
    this.showShippingRecord = true;
  }
}
